export const env = {
  graphqlUrl: import.meta.env.VITE_GRAPHQL_API_URL,
} as const
